import React, { FC } from 'react';
import ExternalLinkDialog from './components/ExternalLinkDialog';
import useBooleanState from 'src/hooks/useBooleanState';
import { Alert } from '@material-ui/lab';
import { Button } from '@material-ui/core';

interface Props {
  ticketId: string;
}

const ExternalLinkAlert: FC<Props> = ({ ticketId }) => {
  const [isOpen, , open, close] = useBooleanState(false);

  return (
    <>
      <Alert
        severity='info'
        action={
          <Button size='small' color='inherit' onClick={open}>
            Générer un lien
          </Button>
        }
      >
        Pour permettre au prestataire de completer le bon d'intervention, vous pouvez lui générer un lien externe.
      </Alert>

      <ExternalLinkDialog onClose={close} open={isOpen} ticketId={ticketId} />
    </>
  );
};

export default ExternalLinkAlert;
